var _defs, _g, _g2, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceCo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1007"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2907",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2908",
    stopOpacity: 0.5,
    stopColor: "#ffc9b5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2909",
    stopOpacity: 0,
    stopColor: "#f5af95",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2911",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2912",
    stopOpacity: 0.5,
    stopColor: "#ffc9b5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2913",
    stopOpacity: 0,
    stopColor: "#f5af95",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3086",
    x1: 100,
    y1: 171,
    x2: 100,
    y2: 127,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3087",
    stopOpacity: 0.8,
    stopColor: "#e69375",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3088",
    stopOpacity: 1,
    stopColor: "#c7633d",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3137",
    x1: 100,
    y1: 142,
    x2: 100,
    y2: 139,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3138",
    stopOpacity: 1,
    stopColor: "#eda184",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3139",
    stopOpacity: 1,
    stopColor: "#e69375",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4445",
    cx: 129.041,
    cy: 83.945,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8281 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4446",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4447",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.315
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4448",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4449",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4450",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4452",
    cx: 128.643,
    cy: 83.986,
    r: 15.116,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1738 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4453",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4454",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4455",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4456",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4457",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4459",
    cx: 129.041,
    cy: 83.945,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8281 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4460",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4461",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4462",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4463",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4464",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4468",
    cx: 121.986,
    cy: 82.496,
    fx: 133.239,
    fy: 82.527,
    r: 16.003,
    gradientTransform: "matrix(0.9998 0.0208 0.0166 -0.7998 -45.3195 145.9395)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4469",
    stopOpacity: 1,
    stopColor: "#e69375",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4470",
    stopOpacity: 0.3,
    stopColor: "#e69375",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4471",
    stopOpacity: 0,
    stopColor: "#f5af95",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4473",
    cx: 68.931,
    cy: 105.995,
    r: 29.524,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.6796 1.3127)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4474",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4475",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4479",
    cx: 128.643,
    cy: 83.986,
    r: 15.116,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1738 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4480",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4481",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4482",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4483",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4484",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4488",
    cx: 121.587,
    cy: 82.496,
    fx: 132.839,
    fy: 82.527,
    r: 16.003,
    gradientTransform: "matrix(-0.9998 0.0208 -0.0166 -0.7998 244.5208 145.9478)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4489",
    stopOpacity: 1,
    stopColor: "#e69375",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4490",
    stopOpacity: 0.3,
    stopColor: "#e69375",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4491",
    stopOpacity: 0,
    stopColor: "#f5af95",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4493",
    cx: 69.316,
    cy: 105.995,
    r: 29.524,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.6796 1.3127)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4494",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4495",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4616",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4617",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4618",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4620",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4621",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4622",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4626",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4627",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4628",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4630",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4631",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4632",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4634",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4635",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4636",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4639",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4640",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4641",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4643",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4644",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4645",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4649",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4650",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4651",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4653",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4654",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4655",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4657",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4658",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4659",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(0.8499995000000001,0,0,0.8499995000000001,14.957440929289803,17.120044459050163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4787",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#2f1409",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2914",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#f5af95",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2915",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#ffc9b5",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2916",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#e69375",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2917",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#c7633d",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3085",
    d: "M100.002 170.866c11.391 0 16.629-6.36 24.218-9.638 -0.008-7.932 2.039-23.933 3.282-32.907 -16.136-1.852-38.871-1.852-55.006 0.001 1.243 8.973 3.29 24.972 3.281 32.903C83.37 164.502 88.608 170.866 100.002 170.866z",
    fill: "url(#SvgjsLinearGradient3086)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4891",
    d: "M-3.682 236.192c-2.914-24.293 8.022-47.09 34.496-54.611 7.77-2.208 5.691-3.341 6.867-3.41 -0.039-0.211-0.045-0.2-0.045-0.63h-0.036c0.087-8.03 9.028-6.453 11.587-6.984 10.121-2.158 13.558-12.786 25.115-9.985 0.284 2.437 0.075 5.248-1.371 15.663 10.899 23.466 22.722 21.437 26.925 34.571 3.815-11.746 17.339-13.617 27.306-34.576 -0.655-5.884-2.083-11.033-1.482-15.935l0.057-0.042c7.744-2.583 11.127 0.874 14.21 3.854 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481l0.096 0.104C181.094 235.667 57.546 241.095-3.682 236.192z",
    fill: "#386e77",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4892",
    d: "M100.268 209.685c4.229-10.638 16.946-13.132 26.543-32.755 0.098-0.108 0.347-0.591 0.656-1.237 -0.164-1.826-0.372-3.747-1.213-5.757 -0.522-3.35-0.939-6.489-0.587-9.535 1.974 0.578 3.842 1.262 5.12 2.66 1.882 2.052 0.455 5.609-1.346 9.042C126.063 186.844 117.594 197.493 100.268 209.685zM169.282 198.859c2.938 10.376 4.895 26.928 2.544 37.445 1.962-0.045 2.686-0.097 4.506-0.138C177.146 225.12 175.154 207.48 169.282 198.859zM137.604 200.735c-12.805 7.48-25.687 10.358-37.321 20.291 -11.64-9.904-24.647-11.637-37.453-19.108 -5.87-2.36-14.874-10.699-20.377-16.572 17.313 26.284 29.706 18.823 57.434 36.538 27.736-17.715 40.205-11.692 57.516-37.974C151.9 189.782 143.476 198.39 137.604 200.735zM99.81 210.936c-4.238-10.644-16.459-14.383-26.056-34.006 -0.093-0.108-0.343-0.591-0.652-1.237 0.156-1.826-0.262-3.841 0.586-5.857 0.521-3.358 0.748-6.092 0.393-9.132 -1.969 0.574-3.025 0.959-4.303 2.357 -1.88 2.052-0.453 5.609 1.347 9.042C74.502 186.844 82.479 198.74 99.81 210.936zM27.163 197.688c-4.305 9.396-4.34 27.432-3.528 38.479 1.821 0.041 2.548 0.093 4.506 0.138C25.791 225.787 26.379 208.26 27.163 197.688zM99.888 212.964c16.389-4.909 33.813-13.894 48.305-35.847 -13.084 17.643-32.525 28.063-47.926 34.455 -15.89-5.762-34.915-17.221-46.006-32.635C67.257 200.226 83.508 208.055 99.888 212.964z",
    fill: "#265e68",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4893",
    d: "M202.762 235.667c-0.115 0-0.256 0.001-0.374 0.001 -0.427-48.615-27.497-50.574-42.48-53.725 -2.345 0-3.563-6.505-5.288-8.24 -1.467-1.475-12.769-1.475-16.348-11.169 0.583 0.513 1.131 1.052 1.674 1.573 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481L202.762 235.667zM-3.968 236.84c0.114 0 0.255 0.001 0.376 0.001 4.759-38.632 16.029-50.811 43.543-55.364 3.451-1.313 1.634-3.81 3.362-5.544 1.467-1.468 9.627-1.5 20.924-13.389 -0.582 0.513-3.075 1.042-3.615 1.563 -9.398 9.083-16.485 6.51-19.088 7.457 -3.209 1.188-3.707 4.028-3.707 6.546 -21.414 3.111-44.161 14.974-41.702 58.626L-3.968 236.84z",
    fill: "#4d7e86",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4894",
    d: "M161.69 177.978c0-9.858-9.265-7.895-13.529-8.812 -9.409-2.02-9.113-12.916-22.582-8.985 -0.574 4.657 0.516 8.738 1.473 15.997 -9.877 20.755-23.576 23.093-27.196 34.245 -3.957-12.38-16.045-11.134-26.81-34.171 1.498-10.838 1.648-13.354 1.36-15.774 -10.271-2.349-12.588 4.32-21.876 8.776 -5.637 2.642-7.229 0.263-12.067 2.633 -2.007 0.968-3.018 3.609-2.946 5.767 -0.013 0.01 0 0.01 0 0.01 0 0.139 0 0.267 0.023 0.396 -1.175 0.082 0.546 0.074-7.323 1.346 -25.363 4.1-36.61 25.534-34.005 56.906 11.89 0 1.011 4.382 183.147-0.077 8.456-0.214 22.799-0.447 23.402-0.447C208.321 189.265 184.836 181.568 161.69 177.978zM-3.624 236.057c2.579-36.004 8.018-50.026 41.046-57.329 17.978 29.839 39.98 25.499 62.232 42.189 -20.166-16.771-41.302-14.549-61.622-42.583 -0.228-2.354 1-4.943 3.535-5.959 1.796-0.702 3.72-0.498 5.6-0.488 7.087 0.054 12.546-5.502 17.793-9.578 2.499-1.67 6.22-1.752 9.2-1.292 0.231 3.874-1.262 9.721-1.762 13.845 -1.042-2.295-2.029-4.664-3.015-7.022 12.47 36.624 24.903 28.334 30.461 43.525 -1.177-0.327-21.014-7.468-36.822-23.188 -3.358-3.325-10.011-10.656-10.516-11.34 19.573 26.51 32.079 27.86 47.391 34.691 0 0.01 0.021 0.035 0.021 0.048 0.012 0.036 0.068 0.221 0.086 0.256 0.074-0.033 0.158-0.07 0.239-0.091 0.026-0.022 0.047-0.033 0.08-0.033 2.122-1.043 16.065-5.902 26.681-13.2 10.927-7.517 23.39-23.821 22.451-22.64 -18.253 18.573-21.075 22.785-49.212 35.67 -0.027 0-0.048-0.01-0.069-0.021 -0.022-0.131-0.064-0.257-0.107-0.387 0.011-0.062 0.032-0.121 0.054-0.178 4.948-13.579 19.476-8.33 31.51-45.554 -1.232 3.216-2.527 6.382-3.979 9.486 -0.457-5.455-2.042-9.756-1.865-14.247 2.084-0.693 7.742-1.022 9.308 0.542 6.529 5.586 7.059 9.677 17.696 9.677 3.411 0.02 7.871 0.45 8.375 6.708 -0.627 0.922-5.291 6.431-9.703 10.809 -15.438 15.368-29.249 15.664-50.619 32.007 0.521 0 1.605-1.131 2.029-1.418 16.712-11.864 28.719-11.677 44.085-24.249 7.082-5.785 13.897-15.044 14.63-16.222 0.022 0.013 0.059 0.013 0.079 0.013 28.198 4.853 42.321 15.462 40.764 57.069C76.043 234.783 58.884 238.145-3.624 236.057z",
    fill: "#0c4049",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3196",
    d: "M47.001 83.231c-1.376-2.453-5.638-8.48-9.98-7.003 -2.749 0.935-3.293 3.993-3.735 6.693 -0.588 3.591 0.471 10.694 1.389 13.26 0.881 2.467 3.533 7.23 5.264 9.045 2.13 2.225 4.775 9.324 5.194 10.061 0.66 1.162 1.536 2.911 4.122 2.692 2.853-0.244 4.584-1.85 5.856-2.121C58.253 115.192 50.582 89.616 47.001 83.231z",
    fill: "#f5af95",
    stroke: "#c7633d",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3197",
    d: "M44.197 98.104c-0.132-0.581 0.007-1.56 0.142-2.504 0.124-0.861 0.24-1.675 0.169-2.251 -0.267-2.154-1.773-6.249-2.757-8.467 -1.132-2.554-2.963-5.77-5.262-6.599 -0.95-0.343-1.575 0.067-1.938 0.484 -0.266 0.305-0.325 0.665-0.238 0.707 0.086 0.042 0.285-0.254 0.572-0.535 0.235-0.229 0.579-0.426 1.051-0.385 -0.19 1.073-1.167 6.883-0.744 10.845 0.333 3.115 1.593 5.442 1.79 5.791 0.029 0.367 0.077 0.726 0.148 1.075 0.929 4.547 4.971 9.717 6.378 11.409 0.259 0.313 0.531 0.497 0.598 0.423 0.066-0.076-0.094-0.387-0.353-0.7 -1.388-1.679-5.391-6.831-6.289-11.218 -0.952-4.656 2.318-11.556 3.048-13.017 0.371 0.685 0.687 1.344 0.93 1.893 0.19 0.431 0.402 0.936 0.619 1.479 -0.429 0.762-3.434 6.32-2.338 10.767 0.406 1.641 2.235 3.755 3.447 4.333 0.667 0.32 0.919 0.797 1.209 1.349 0.336 0.64 0.718 1.365 1.828 1.892 0.225 0.108 0.429 0.151 0.61 0.151 0.313 0 0.551-0.135 0.725-0.293 0.018 0.28 0.017 0.64 0.009 0.97 -0.012 0.431 0.042 0.783 0.137 0.791 0.094 0.008 0.196-0.332 0.207-0.76 0.016-0.526 0.013-1.177-0.072-1.488 -0.248-0.917-1.008-1.953-1.813-3.048C45.221 100.116 44.403 99.003 44.197 98.104zM36.95 94.073c-2.177-7.139 0.656-13.3 1.144-14.28 0.85 0.822 1.6 1.919 2.21 2.995C39.86 83.646 37.041 89.271 36.95 94.073zM46.341 104.515c-1.004-0.475-1.339-1.115-1.666-1.733 -0.293-0.559-0.598-1.136-1.369-1.505 -0.168-0.081-0.352-0.203-0.542-0.343 -2.486-6.263 0.272-9.001 0.963-9.562 0.211 0.766 0.369 1.468 0.439 2.031 0.063 0.517-0.052 1.339-0.167 2.134 -0.142 0.985-0.286 2.004-0.137 2.664 0.226 0.982 1.069 2.131 1.884 3.242 0.723 0.986 1.466 2.003 1.721 2.832C47.359 104.439 47.017 104.836 46.341 104.515z",
    fill: "#c7633d",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3198",
    d: "M152.736 83.231c1.377-2.453 5.639-8.48 9.98-7.003 2.75 0.935 3.293 3.993 3.736 6.693 0.588 3.591-0.471 10.694-1.389 13.26 -0.881 2.467-3.533 7.23-5.266 9.045 -2.129 2.225-4.775 9.324-5.193 10.061 -0.658 1.162-1.535 2.911-4.121 2.692 -2.854-0.244-4.584-1.85-5.857-2.121C141.484 115.192 149.156 89.616 152.736 83.231z",
    fill: "#f5af95",
    stroke: "#c7633d",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3199",
    d: "M153.727 101.196c-0.805 1.096-1.564 2.131-1.813 3.048 -0.086 0.311-0.088 0.962-0.072 1.488 0.012 0.428 0.113 0.768 0.207 0.76s0.148-0.36 0.137-0.791c-0.008-0.331-0.008-0.69 0.01-0.97 0.174 0.158 0.412 0.293 0.725 0.293 0.182 0 0.385-0.043 0.609-0.151 1.109-0.526 1.492-1.252 1.828-1.892 0.289-0.552 0.543-1.028 1.209-1.349 1.213-0.578 3.041-2.692 3.447-4.333 1.096-4.447-1.908-10.005-2.338-10.767 0.217-0.544 0.43-1.049 0.619-1.479 0.244-0.549 0.559-1.208 0.93-1.893 0.73 1.46 4 8.361 3.049 13.017 -0.896 4.387-4.9 9.539-6.289 11.218 -0.258 0.313-0.418 0.624-0.352 0.7 0.066 0.074 0.338-0.109 0.598-0.423 1.406-1.692 5.449-6.862 6.379-11.409 0.07-0.35 0.117-0.708 0.146-1.075 0.197-0.349 1.459-2.676 1.791-5.791 0.422-3.961-0.555-9.772-0.744-10.845 0.473-0.042 0.814 0.156 1.051 0.385 0.287 0.281 0.486 0.577 0.572 0.535 0.086-0.042 0.027-0.402-0.238-0.707 -0.363-0.417-0.988-0.827-1.938-0.484 -2.299 0.83-4.131 4.045-5.262 6.599 -0.984 2.218-2.49 6.313-2.758 8.467 -0.072 0.576 0.045 1.39 0.17 2.251 0.135 0.945 0.273 1.924 0.141 2.504C155.336 99.003 154.518 100.116 153.727 101.196zM159.434 82.787c0.611-1.075 1.361-2.173 2.211-2.995 0.488 0.98 3.32 7.141 1.145 14.28C162.697 89.271 159.879 83.646 159.434 82.787zM152.27 104.275c0.254-0.829 0.998-1.846 1.721-2.832 0.816-1.111 1.658-2.26 1.885-3.242 0.148-0.66 0.004-1.679-0.137-2.664 -0.115-0.795-0.23-1.617-0.166-2.134 0.068-0.563 0.227-1.266 0.438-2.031 0.691 0.561 3.449 3.299 0.965 9.562 -0.191 0.14-0.375 0.263-0.543 0.343 -0.771 0.369-1.074 0.946-1.369 1.505 -0.326 0.618-0.662 1.258-1.666 1.733C152.721 104.836 152.379 104.439 152.27 104.275z",
    fill: "#c7633d",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3082",
    d: "M100.002 0.867C66.384 0.92 39.082 28.536 39.134 62.56c0.009 5.403 0.704 10.643 2.002 15.634h0.001c0.012 0.054 8.12 35.809 11.82 47.522 2.775 8.787 14.288 21.989 22.398 25.322 7.826 3.217 13.039 9.828 24.646 9.828s16.82-6.611 24.646-9.828c8.11-3.333 19.624-16.535 22.398-25.322 3.7-11.713 11.809-47.468 11.819-47.522h0.002c1.298-4.992 1.994-10.231 2.002-15.634C160.923 28.536 133.62 0.92 100.002 0.867z",
    fill: "#f5af95",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3083",
    d: "M140.727 16.737c10.424 11.164 16.867 26.574 16.844 43.586 -0.009 5.403-0.666 10.643-1.894 15.634h-0.001c-0.011 0.054-7.681 35.809-11.18 47.522 -2.623 8.788-13.515 21.989-21.184 25.322 -7.403 3.216-12.333 9.829-23.31 9.829 -10.978 0-15.908-6.613-23.309-9.829 -7.671-3.333-18.56-16.534-21.184-25.322 -3.5-11.713-11.168-47.468-11.18-47.522h-0.001c-1.229-4.992-1.886-10.231-1.894-15.634 -0.025-17.011 6.418-32.419 16.84-43.583C46.893 28.034 39.106 44.38 39.134 62.56c0.009 5.403 0.704 10.643 2.002 15.634h0.001c0.012 0.054 8.12 35.809 11.82 47.522 2.775 8.787 14.288 21.989 22.398 25.322 7.826 3.217 13.039 9.828 24.646 9.828s16.82-6.611 24.646-9.828c8.11-3.333 19.624-16.535 22.398-25.322 3.7-11.713 11.809-47.468 11.819-47.522h0.002c1.298-4.992 1.994-10.231 2.002-15.634C160.898 44.378 153.111 28.031 140.727 16.737z",
    fill: "#eda184",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3084",
    d: "M100.002 0.867C66.384 0.92 39.082 28.536 39.134 62.56c0.009 5.403 0.704 10.643 2.002 15.634h0.001c0.012 0.054 8.12 35.809 11.82 47.522 2.775 8.787 14.288 21.989 22.398 25.322 7.826 3.217 13.039 9.828 24.646 9.828s16.82-6.611 24.646-9.828c8.11-3.333 19.624-16.535 22.398-25.322 3.7-11.713 11.809-47.468 11.819-47.522h0.002c1.298-4.992 1.994-10.231 2.002-15.634C160.923 28.536 133.62 0.92 100.002 0.867z",
    fill: "none",
    stroke: "#c7633d",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,-1,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(1.350001300000001,0,0,1.350001300000001,-35.17513065000011,-47.819135895744466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3136",
    d: "M100.2 142.947c-2.832 0.144-3.644-2.753-3.644-2.753s3.931 0.565 6.991-0.353C103.548 139.842 102.692 142.822 100.2 142.947z",
    fill: "url(#SvgjsLinearGradient3137)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3140",
    d: "M100.488 140.76c-1.984 0.1-3.765-0.077-3.877-0.089 -0.138-0.014-0.238-0.136-0.224-0.272 0.015-0.138 0.143-0.233 0.274-0.224 0.041 0.003 4.096 0.405 6.738-0.337 0.131-0.032 0.271 0.041 0.309 0.174s-0.04 0.27-0.173 0.308C102.601 140.582 101.517 140.708 100.488 140.76z",
    fill: "#c7633d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3141",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3142",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "none",
    stroke: "#c7633d",
    strokeWidth: 0.75,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4444",
    d: "M61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "url(#SvgjsRadialGradient4445)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0.25,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4670",
    d: "M79.788 85.588c-0.869 3.192-4.162 5.073-7.361 4.196 -3.197-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.168-5.076 7.365-4.198C78.772 79.09 80.659 82.392 79.788 85.588z",
    fill: "#4d3623",
    stroke: "#1f1105",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4671",
    d: "M78.855 85.662c-0.849 2.452-3.407 3.881-5.899 3.199 -2.3-0.631-3.752-2.838-3.563-5.171 0.853-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.592 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.039-0.147 0.06-0.294 0.065-0.439C77.29 84.782 78.088 85.165 78.855 85.662z",
    fill: "#5c4633",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4672",
    d: "M74.813 82.21c-1.203-0.344-2.429 0.342-2.739 1.54 -0.311 1.191 0.412 2.438 1.614 2.783 1.204 0.345 2.43-0.342 2.741-1.534C76.742 83.801 76.016 82.555 74.813 82.21zM75.075 86.442c-0.5 0.156-1.017-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C75.881 85.831 75.582 86.287 75.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4673",
    d: "M70.811 87.159c-0.37 0.222-0.922 0.023-1.238-0.447 -0.316-0.466-0.269-1.024 0.102-1.247 0.368-0.219 0.925-0.021 1.239 0.446C71.226 86.378 71.181 86.938 70.811 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4674",
    d: "M78.71 83.74c-0.846 0.507-2.117 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.844-0.509 2.118-0.053 2.834 1.019C79.66 81.954 79.556 83.232 78.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4466",
    d: "M53.294 83c0.809 10.899 11.637 23.583 20.506 22.236 10.498 0.106 20.864-7.868 20.864-22.305s-5.087-26.528-21.127-26.528C62.037 56.402 53.294 68.563 53.294 83zM61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "#f5af95",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4467",
    d: "M72.262 90.163c3.614 0.398 13.873-1.561 14.253-2.847 0.687-2.32-4.534-6.921-12.052-7.844C68.003 78.68 62.9 79.816 61.907 81.6c0.898-6.4 7.7-11.397 15.987-11.434 8.911-0.037 16.148 5.676 16.172 12.765 0.021 7.088-7.185 12.862-16.095 12.902 -8.913 0.037-16.149-5.676-16.173-12.764 0-0.105 0.016-0.208 0.019-0.313C63.147 88.083 68.651 89.764 72.262 90.163z",
    fill: "url(#SvgjsRadialGradient4468)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4472",
    d: "M61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "url(#SvgjsRadialGradient4473)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4476",
    d: "M62.148 77.417c4.208-1.978 9.35-2.16 13.838-1.005 2.404 0.561 4.965 1.285 7.063 2.638 1.945 1.135 3.525 2.5 5.002 4.19 -1.342-1.701-2.773-3.118-4.623-4.27 -2.276-1.416-4.769-2.294-7.364-2.916C71.478 74.928 66.342 75.184 62.148 77.417z",
    fill: "#c7633d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4477",
    d: "M62.769 78.02c0.88-0.352 4.065-1 5.456-1.066 1.687-0.082 5.073 0.125 6.735 0.424 3.374 0.608 9.251 2.483 11.678 7.184 0.746 1.445 0.074 2.456-0.123 2.675 0.3-2.426-4.838-6.746-12.052-7.604 -7.52-0.894-13.217 0.743-12.711 2.958 1.222 5.348 6.846 7.013 10.51 7.405 4.099 0.439 11.684-1.539 12.686-1.753 -1.999 1.009-7.524 2.095-9.767 2.303 -0.744 0.07-2.24 0.104-2.986 0.085 -5.949-0.158-10.169-3.175-11.729-7.26C59.464 80.745 60.56 78.902 62.769 78.02z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4451",
    d: "M137.849 82.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.003 89.758 136.627 88.04 137.849 82.523z",
    fill: "url(#SvgjsRadialGradient4452)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,-0.25,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4675",
    d: "M131.788 85.588c-0.869 3.192-4.162 5.073-7.362 4.196 -3.196-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.169-5.076 7.365-4.198C130.772 79.09 132.658 82.392 131.788 85.588z",
    fill: "#4d3623",
    stroke: "#1f1105",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4676",
    d: "M130.855 85.662c-0.849 2.452-3.408 3.881-5.899 3.199 -2.3-0.631-3.753-2.838-3.563-5.171 0.854-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.593 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.038-0.147 0.06-0.294 0.065-0.439C129.29 84.782 130.089 85.165 130.855 85.662z",
    fill: "#5c4633",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4677",
    d: "M126.813 82.21c-1.202-0.344-2.429 0.342-2.738 1.54 -0.312 1.191 0.412 2.438 1.613 2.783 1.204 0.345 2.431-0.342 2.742-1.534C128.741 83.801 128.016 82.555 126.813 82.21zM127.075 86.442c-0.5 0.156-1.018-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C127.881 85.831 127.582 86.287 127.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4678",
    d: "M122.812 87.159c-0.37 0.222-0.923 0.023-1.238-0.447 -0.316-0.466-0.27-1.024 0.102-1.247 0.367-0.219 0.926-0.021 1.239 0.446C123.227 86.378 123.181 86.938 122.812 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4679",
    d: "M130.71 83.74c-0.846 0.507-2.116 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.845-0.509 2.117-0.053 2.834 1.019C131.66 81.954 131.557 83.232 130.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4486",
    d: "M126.063 56.402c-16.04 0-21.127 12.091-21.127 26.528s10.366 22.412 20.864 22.305c8.869 1.347 19.697-11.337 20.506-22.236C146.307 68.563 137.563 56.402 126.063 56.402zM127.339 90.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 7.52-0.922 13.217 0.767 12.711 3.051C136.627 88.04 131.003 89.758 127.339 90.163z",
    fill: "#f5af95",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4487",
    d: "M127.339 90.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 6.46-0.792 11.563 0.345 12.556 2.128 -0.898-6.4-7.7-11.397-15.987-11.434 -8.911-0.037-16.148 5.676-16.172 12.765 -0.021 7.088 7.185 12.862 16.095 12.902 8.913 0.037 16.149-5.676 16.173-12.764 0-0.105-0.016-0.208-0.019-0.313C136.453 88.083 130.949 89.764 127.339 90.163z",
    fill: "url(#SvgjsRadialGradient4488)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4492",
    d: "M137.849 82.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.003 89.758 136.627 88.04 137.849 82.523z",
    fill: "url(#SvgjsRadialGradient4493)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4496",
    d: "M137.452 77.417c-4.208-1.978-9.35-2.16-13.838-1.005 -2.404 0.561-4.965 1.285-7.063 2.638 -1.945 1.135-3.525 2.5-5.002 4.19 1.342-1.701 2.773-3.118 4.623-4.27 2.276-1.416 4.769-2.294 7.364-2.916C128.123 74.928 133.259 75.184 137.452 77.417z",
    fill: "#c7633d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4497",
    d: "M136.832 78.02c-0.88-0.352-4.065-1-5.456-1.066 -1.687-0.082-5.073 0.125-6.735 0.424 -3.374 0.608-9.251 2.483-11.678 7.184 -0.746 1.445-0.074 2.456 0.123 2.675 -0.3-2.426 4.838-6.746 12.052-7.604 7.52-0.894 13.217 0.743 12.711 2.958 -1.222 5.348-6.846 7.013-10.51 7.405 -4.099 0.439-11.684-1.539-12.686-1.753 1.999 1.009 7.524 2.095 9.767 2.303 0.744 0.07 2.24 0.104 2.986 0.085 5.949-0.158 10.169-3.175 11.729-7.26C140.137 80.745 139.041 78.902 136.832 78.02z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2906",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient2907)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2910",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient2911)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,-3,2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(0.9825664732332879,-0.18591160716291474,0.18591160716291474,0.9825664732332879,-12.615797905031314,14.479777009877608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(0.8999997000000001,0,0,0.8999997000000001,7.320009829226294,7.017069696165464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4783",
    d: "M74.799 71.28c-4.425-0.475-21.252 3.714-21.252 3.714s16.789-6.74 23.757-5.667c5.188 0.798 14.397 5.077 12.706 7.339C88.649 78.487 84.408 72.312 74.799 71.28z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,3,2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(0.9825664725843343,0.1859116105927184,-0.1859116105927184,0.9825664725843343,16.099930960520197,-22.622476668705417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(0.8999997000000001,0,0,0.8999997000000001,12.683687876999272,7.03277332603988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4784",
    d: "M109.731 76.398c-1.713-2.292 7.592-6.31 13.546-6.804 7.117-0.59 22.914 4.085 22.914 4.085s-15.9-2.628-20.377-2.106C115.998 72.718 111.11 78.243 109.731 76.398z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3157",
    d: "M91.115 115.499c-0.878 2.064 5.934 4.292 8.519 4.429 2.8 0.147 10.646-2.9 9.316-4.992 -1.399-2.195-6.643-0.286-8.906-0.286C97.792 114.649 92.291 112.745 91.115 115.499z",
    fill: "#e69375",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3158",
    d: "M101.857 117.058c-0.23-0.759 1.876-1.584 2.657-1.694 1.101-0.16 3.36 0.802 3.158 1.592 -0.184 0.698-2.148-0.533-2.86-0.429C104.078 116.634 102.075 117.769 101.857 117.058zM94.974 116.811c0.968 0 2.404 0.623 2.668 0.074 0.315-0.655-2.139-1.461-2.86-1.372 -0.596 0.07-2.733 1.315-2.439 1.839C92.617 117.833 93.698 116.811 94.974 116.811z",
    fill: "#c7633d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3159",
    d: "M100.089 111.999c0.607 0 1.742-0.74 1.792-2.23 0.201-6.008-0.956-23.833-1.792-23.77 -0.78 0.059-2.267 17.637-1.948 23.77C98.22 111.271 99.404 111.999 100.089 111.999z",
    fill: "#ffdbce",
    strokeWidth: "none",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4842",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4802",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4789",
    d: "M152.176 96.021c-4.33-11.451-2.396-20.042-3.227-37.21 -1.283-26.428-7.483-23.179-21.749-24.214C105.156 33 97.497 22.794 81.063 22.794c-8.887 0-19.24 4.048-27.173 11.001 -6.378 43.485 2.638 39.87-6.744 61.845 -5.953-6.247-6.721-15.865-11.134-28.495 -3.519-10.451-2.658-11.011-6.527-16.049 2.484 0.449 2.734 0.429 3.842 0.429 -1.97-4.306-4.479-11.951-5.429-15.273 2.329-1.116 4.839-3.909 6.47-5.919 -0.931-2.128-1.646-4.554-2.079-6.625 0.077-0.026 0.438-0.16 0.438-0.16l0.004-0.017c5.681-2.417 6.84-15.944 10.785-19.389 1.941-1.814 3.806-2.531 5.534-3.446 0.204-1.895 0.295-2.277 0.575-3.63 9.402-2.521 12.254-1.199 25.53-4.893 4.564-1.27 7.709-2.153 17.317-1.75 3.525 1.779 16.06 10.479 25.484 1.602 7.254 4.527 13.574 5.105 22.624 10.252 15.179 8.89 17.244 15.147 16.352 29.56 10.493 13.965 8.167 30.567 3.577 47.23C157.639 89.383 154.886 92.761 152.176 96.021z",
    fill: "#2f1409",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4790",
    d: "M152 82c-1-8 3-15 4-22 -1 2-3 3-3 5 0-7 3-13 2-20 -1 2-2 3-4 4 3-7 0-15-5-21 1 3 2 5 2 8 -6-9-20-10-30-15 2 3 6 5 9 7 -14-5-27-11-40-17 2.206 2.206 3.875 6.024 6.589 7.499 1.143 0.163 0.978 0.531 0 0C81.581 16.79 68.958 15.479 58 10c0 4 3 7 6 9 -3 0-6-3-8-2 -3 2 3 4 2 6 -3 2-6-1-9-1 2 3 0 8 2 11 -2-1-4-3-4-2 -1 4-3 5-3 8 0 5 3 10 3 15 0-1.608-1.938-1.279-2.697-2.127 5.009 13.975 4.782 28.692 2.606 43.497 0.082 0.089 0.154 0.184 0.237 0.271 9.382-21.975 0.366-18.36 6.744-61.845 7.933-6.953 18.286-11.001 27.173-11.001 16.435 0 24.094 10.207 46.138 11.802 14.266 1.036 20.466-2.214 21.749 24.214 0.83 17.168-1.104 25.759 3.227 37.21 0.005-0.005 0.009-0.011 0.014-0.016C152.841 88.595 155 81.796 155 75 154 77 153 79 152 82z",
    fill: "#100500",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4791",
    d: "M159.263 71.488C158.954 72.145 157 72.343 157 73c0-3 3.516-5.243 2.924-10.264 0 0.396-3.158 2.95-3.475 3.346 -0.206 1 4.288-10.681 4.288-14.542C159.263 53.999 158 54 158 56c0-4-0.006-9.854-0.006-13.854 0 2-1.994 4.949-1.994 6.949 0.933-7.464-3.404-16.095-4.28-23.501 -0.511 1.795-1.479 3.889-0.72 5.406 -3-4-2-11-7-14 -1 2-1 4-2 6 -3-4-7-7-9-11 0 2 0 3 0 5 -5-4-12-6-15-12 0 2 0 5 0 7 -4-1-10.495-4.596-12.495-7.596C105.505 7.404 109 12 109 15c-8-4-14-10-22-14 0 2 2 4 1 6 -4-2-11.771-2-13.771-6 0 3 3.11 6 3.11 9 -9-1-11.009-3.822-19.242-7.596C57.097 4.404 56 7 55 9c-2-2-3-4-6-4 0 3 3 7 1 10 -1 1-5-3-5-2 -2 4 0 10-2 14 0 1-3-2-5-1 3.872 5.807 1.202 12.548 3.745 18.416C41.843 44.598 41.93 44.79 42 45c-0.096-0.193-0.17-0.389-0.255-0.584C40.452 41.988 36.93 41.79 36 39c0 7.303 4.157 13.774 5.645 20.932C42.15 60.233 42.404 60.788 42 62c-0.087-0.697-0.214-1.385-0.355-2.068C40.897 59.486 39.596 59.596 39 59c4.728 9.455 6.191 25.673 7.909 36.369 3.545-15.374 1.709-31.456-2.606-43.497C44.118 51.666 44 51.392 44 51c0.109 0.29 0.198 0.582 0.303 0.873C45.063 52.721 47 52.392 47 54c0-5-3-10-3-15 0-3 2-4 3-8 0-1 2 1 4 2 -2-3 0-8-2-11 3 0 6 3 9 1 1-2-5-4-2-6 2-1 5 2 8 2 -3-2-6-5-6-9 10.958 5.479 23.581 6.79 35.589 8.499C90.875 17.024 89.206 13.206 87 11c13 6 26 12 40 17 -3-2-7-4-9-7 10 5 24 6 30 15 0-3-1-5-2-8 5 6 8 14 5 21 2-1 3-2 4-4 1 7-2 13-2 20 0-2 2-3 3-5 -1 7-5 14-4 22 1-3 2-5 3-7 0 6.796-2.159 13.595-2.811 21.004 0.814-0.979 1.633-1.975 2.457-3.163C154.545 85.429 157.479 79.338 159.263 71.488z",
    fill: "#200b03",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4792",
    d: "M93.119 18.235c-1.128 0.089-2.468 0.279-4.94-0.096 -6.698-0.927-28.617-1.793-29.81-8.654 1.055 3.353 7.405 4.299 12.204 5.198 0 0 3.382 0.651 8.723 1.251C89.291 17.101 87.179 17.888 93.119 18.235zM115.897 23.746C92 13.389 93.7 14.531 88.119 10.985c7.333 6.156 9.839 6.172 22.619 12.018 5.921 2.667 7.078 2.561 15.131 4.482C120.224 25.241 119.559 25.287 115.897 23.746zM118.619 20.735c9.914 8.153 22.008 6.125 29.75 15C142.164 25.918 128.518 26.908 118.619 20.735zM59.905 17.331c-2.668-0.805-3.997-0.43-5.286 0.404 4.225-1.989 8.651 2.923 13.75 1.5C66.006 19.523 59.905 17.53 59.905 17.331zM57.051 23.932c-2.328-0.734-5.203-1.979-7.151-1.927 -1.03 0.024-1.281 0.48-1.281 0.48 0.975-1.139 5.609 1.099 8.396 1.626 0.766 0.16 1.354 0.123 1.354 0.123S57.783 24.176 57.051 23.932zM45.652 35.678c0.687-1.892 1.461-3.751 1.256-5.482 -0.104-0.627-0.309-0.955-0.289-0.96 0.464 1.973-0.313 3.175-1.68 6.136 -3.015 6.453 0.924 11.484 2.43 18.364C46.86 45.866 43.166 42.389 45.652 35.678zM154.369 45.985c0.32 2.168 0.225 3.63-0.154 7.075 0 0-0.695 5.779-2.096 11.425C154.198 59.638 155.94 51.389 154.369 45.985zM155.869 61.485c-3.387 9.387-3.936 12.846-4.5 20.25C155.099 64.497 153.284 73.154 155.869 61.485z",
    fill: "#2f1409",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4793",
    d: "M114.869-1.765c-6.126 0.965-12.52 1.734-24-5.25C101.949-1.999 107.334-1.517 114.869-1.765zM128.401 0.19c-6.076-2.194-6.475-4.768-11.032-6.205 4.159 1.884 4.127 4.303 9.559 6.761 2.642 1.249 11.822 3.782 17.441 7.439C139.405 3.794 136.066 3.059 128.401 0.19zM60.619-2.015c11.593 0.241 13.441-2.719 26.75-4.25C75.403-6.414 74.136-3.561 60.619-2.015zM90.869-1.765c4.669 0.559 11.405 4.746 13.5 9.5C102.84 2.405 96.201-1.735 90.869-1.765zM116.869-0.265c4.652 2.475 6.308 7.699 12 8.75C123.284 6.637 122.178 1.803 116.869-0.265zM108.869 0.735c1.193 2.033 2.93 4.107 7.5 7C111.036 3.353 110.121 2.431 108.869 0.735zM132.119 5.485c5.115 0.627 10.451 5.663 11 11.25C143.375 11.229 138.428 5.581 132.119 5.485zM149.458 14.007c-2.307-2.946-4.339-3.642-5.339-4.022 1.428 0.741 2.997 1.725 4.866 4.386 0 0 3.437 4.57 4.884 9.614C152.871 17.907 149.458 14.007 149.458 14.007zM54.369-0.265c0.185-0.391 5.324 1.866 5.73 2.03 1.229 0.479 7.383 2.967 9.52 3.22C68.618 4.717 54.423-1.414 54.369-0.265zM45.869 5.985c0.682 0.896 1.458 2.263 2.01 3.245 0 0 0.296 0.523 0.571 1.059 0.27 0.537 0.51 1.086 0.51 1.086C49.634 12.912 49.955 13.861 50 15 50.252 12.019 47.702 7.872 45.869 5.985zM42.869 8.985c-2.517 6.149-2.489 9.708 0 16C41.306 18.681 40.986 15.697 42.869 8.985z",
    fill: "#3e1f12",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4794",
    d: "M157.239 31.745c0.228-3.5 0.323-5.684 0.02-9.14 -1.138-10.129-7.217-15.136-16.529-20.59 -9.158-5.208-15.513-5.751-22.811-10.37 -9.334 9.042-21.935 0.184-25.37-1.52 -16.776-0.716-14.191 2.518-32.75 4.78 -6.844 0.773-9.67 1.72-9.67 1.72 -0.26 0.07-0.52 0.13-0.76 0.2 -0.2 1-0.381 1.616-0.6 3.68 -1.516 0.801-3.484 1.572-5.45 3.41 -4.048 3.536-5.212 17.195-10.83 19.39v0.01c-0.118 0.043-0.428 0.163-0.55 0.18 0.419 2.096 1.188 4.75 2.08 6.79 -1.594 1.959-4.17 4.807-6.48 5.8 0.546 1.98 3.313 10.751 5.32 15.14 -1.1 0-2.003-0.194-4.09-0.56 4.388 5.578 3.281 5.653 6.96 16.58 4.481 12.826 5.208 22.595 11.49 28.9 5.633-10.646 5.146-15.583 5.19-19.41 0.123-5.265-2.433-18.462 1.935-42.798 9.262-8.105 22.378-12.754 34.815-9.932 13.001 2.94 19.525 9.551 38.02 10.89 14.399 1.046 20.201-2.213 21.471 23.93 0.841 17.373-1.163 26.023 3.43 37.78 2.669-3.22 5.645-6.408 8.72-17.46C165.299 62.807 167.816 45.939 157.239 31.745zM161.02 70.726c-3.468 16.597-5.491 19.609-9.061 24.96 -2.882-8.88-2.093-17.47-1.8-26.59 1.486-39.246-8.424-34.825-22.86-35.92 -17.688-1.192-24.622-7.896-37.76-10.54 -11.972-2.45-25.25 0.755-36.35 11.16 -6.045 27.128 0.578 41.608-4.78 55.37 -1.162 2.943-0.429 3.694-1.28 5.84 -4.636-6.978-5.874-16.832-7.41-21.79 -4.784-12.176-4.632-16.171-9.84-21.97 1.271 0.277 2.91 0.457 4.21 0.24 -0.01-0.01-0.01-0.01-0.01-0.02 -0.332-1.001-4.524-12.47-5.75-15.33 2.387-1.152 4.729-3.746 6.35-5.83 -1.292-4.088 0.314 1.902-2.1-6.66 7.366-2.215 6.6-16.125 14.11-21.21 0.997-0.665 1.88-1.213 2.86-1.83 0.221-1.879 0.071-0.771 0.52-3.63 8.803-1.813 12.4-0.024 25.18-4.05 9.681-2.356 16.636-2.269 17.64-2.16 6.167 3.862 9.656 6.038 16.91 5.53 3.323-0.272 5.966-1.878 8.28-4.24 4.01 3.008 8.485 4.831 13.99 7.35 22.244 10.181 24.229 18.459 24.229 32.18 1.398 1.975 2.938 5.099 3.7 7.19C164.593 50.117 163.096 61.037 161.02 70.726z",
    fill: "#010000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4698",
    d: "M143.62 100.1c-2.36 2.2-6.23 3.04-13.56 3.04 -9.78 0-16.18-1.09-20.41-9.51 -3.29-6.54-4.62-13.56-3.02-15.98 2.21-3.34 8.57-5.61 15.67-6.28C134.63 77.23 143.29 88.98 143.62 100.1zM72.01 71.17c-7.64 0.21-15.09 2.35-18.27 7.05 -2.18 3.21-1.69 12.55-0.22 16.94 2 5.99 5.07 7.98 16.42 7.98 9.78 0 16.18-1.09 20.41-9.51 0.42-0.84 0.81-1.69 1.17-2.54C88.29 82.95 81.16 75.43 72.01 71.17z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4699",
    d: "M146.48 95.17c-0.71 2.12-1.56 3.73-2.86 4.94 -0.33-11.12-8.99-22.87-21.33-28.74 9.37-0.89 19.99 0.99 23.97 6.86C148.44 81.44 147.95 90.77 146.48 95.17zM93.38 77.65c-2.79-4.23-12.22-6.73-21.37-6.47 9.16 4.25 16.28 11.77 19.52 19.92C93.94 85.36 94.77 79.76 93.38 77.65z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4700",
    d: "M151.79 73.61c-10.18-5.46-36.14-7.01-45.5 0.15 -0.8 0.47-4.23-0.53-6.29-0.53 -1.95 0-5.42 1.05-6.29 0.53 -9.36-7.16-35.32-5.61-45.5-0.15 -1.46 0.79-1.62 4.51-0.35 5.08 0.91 0.41 1.51 0.98 1.46 1.98C49 86.29 50.55 93.59 51.23 95.6c0.87 2.59 2.44 7.41 9.29 8.6 5.83 1.01 16.43 1.48 21.94-0.17 9.99-2.98 14.24-18.04 14.42-23.17l0.01 0.02c0.4-1.8 5.82-1.8 6.23 0l0.01-0.02c0.17 5.13 4.43 20.19 14.42 23.17 5.51 1.65 16.11 1.18 21.94 0.17 6.85-1.19 8.42-6.01 9.29-8.6 0.68-2.02 2.23-9.31 1.92-14.93 -0.05-1 0.56-1.57 1.46-1.98C153.41 78.12 153.25 74.4 151.79 73.61zM81.41 101.36c-5.06 1.51-14.32 1.61-19.71 0.67 -4.54-0.79-6.44-3.26-7.7-7.03 -1.48-4.4-1.87-13.51 0.16-16.5 6.76-9.98 33.87-8.05 38.8-0.58C95.16 81.27 90.89 98.53 81.41 101.36zM146 95.01c-1.26 3.77-3.17 6.24-7.7 7.03 -5.39 0.94-14.65 0.84-19.71-0.67 -9.48-2.83-13.75-20.09-11.55-23.44 4.93-7.47 32.04-9.4 38.8 0.58C147.87 81.49 147.48 90.61 146 95.01z",
    fill: "#130b3c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4701",
    d: "M118.58 101.32c2.79 0.83 6.86 1.24 10.85 1.27 -12.54 1.22-15.39-3.4-17.12-5.16 -3.52-3.59-5.69-8.95-5.85-16.65C106.49 86.86 110.76 98.99 118.58 101.32zM93.69 73.72c-9.36-7.16-35.32-5.62-45.5-0.15C71.43 67.05 84.93 70.42 93.69 73.72zM61.68 102c-4.54-0.79-6.44-3.26-7.7-7.03 -1.32-3.93-1.77-11.62-0.4-15.35 -1.83 4.22-1.12 12.39 0.26 16.5 1.6 4.8 4.54 7.18 17.34 6.46C67.71 102.65 64.25 102.44 61.68 102zM152.97 76.3c-0.04-1.13-0.45-2.32-1.2-2.73 -9.98-5.36-35.14-6.94-44.93-0.25C120 68.05 138.97 67.31 152.97 76.3z",
    fill: "#1e154b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1057",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1058",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    anchor: "start",
    fill: "#333333",
    x: 57.76717758178711,
    y: 182.48277378082275,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1059",
    dy: 13,
    x: 57.76717758178711
  }, "Created on face.co")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceCo);
export default __webpack_public_path__ + "static/media/face_co.5e7f44458f2de826a4d8fe6c2e4c5d09.svg";
export { ForwardRef as ReactComponent };